import { gql } from "@apollo/client";export default gql`query memeAggregate($where: meme_bool_exp) {
    memeAggregate: meme_aggregate(where: $where) {
        aggregate {
            count
        }
    }
}
`;
